export default {"src":"/_next/static/media/chevronDown_24.1095147b.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};